import { render, staticRenderFns } from "./GenerateReportPageModule.vue?vue&type=template&id=60a053e2"
import script from "./GenerateReportPageModule.vue?vue&type=script&lang=js"
export * from "./GenerateReportPageModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports